//webscoket连接管理工具，用于即时通讯功能。
import store from "@/store";
import router from '@/router'
import { Notification } from 'element-ui';

let wsObj = null;

let wbSocket = {
    isConnectState: false,
    onMessageMonitorList: []
};

// 添加消息监听
export function AddSocketMessageMonitor(id, callback) {
    console.log("添加消息监听id:" + id)
    wbSocket.onMessageMonitorList.push({ id, callback })
}

// 移除消息监听
export function RemoveSocketMessageMonitor(id) {
    console.log("移除消息监听id:" + id)
    wbSocket.onMessageMonitorList = wbSocket.onMessageMonitorList.filter(x => x.id != id);
}

// 初始化websocket + 自动重连
export async function RetryConnect(timeout = 2000) {
    if (wbSocket.isConnectState) return;

    setTimeout(async () => {
        if (!store.getters.UserId) {
            console.log("没有用户id，暂不连接");
            RetryConnect();
            return;
        }

        // 检查是否禁用WebSocket
        if (process.env.VUE_APP_WS_DISABLED === 'true') {
            console.log("WebSocket已禁用");
            return;
        }

        console.log("执行开始连接 WebSocket");
        console.log("当前用户ID:", store.getters.UserId);
        const wsBaseUrl = process.env.VUE_APP_BASE_WS || "ws://124.222.121.78";
        const wsPath = process.env.VUE_APP_WS_PATH || "/websocket";
        const wsUrl = wsBaseUrl + wsPath + "/" + store.getters.UserId;
        console.log("WebSocket连接地址:", wsUrl);
        
        try {
            wsObj = new WebSocket(wsUrl);
            
            wsObj.onmessage = (res) => {
                console.log("收到消息:", res.data);
                try {
                    const socketMessage = JSON.parse(res.data);
                    wbSocket.onMessageMonitorList.forEach(monitor => {
                        monitor.callback({
                            Type: socketMessage.Type,
                            Data: JSON.parse(socketMessage.Data)
                        });
                    });
                } catch (e) {
                    console.error("消息解析错误:", e);
                }
            };

            wsObj.onopen = (event) => {
                console.log("WebSocket 连接成功", event);
                wbSocket.isConnectState = true;
                Notification.success({ title: 'WebSocket提示', message: '连接成功' });
            };

            wsObj.onclose = (event) => {
                console.log("WebSocket 关闭", event);
                wbSocket.isConnectState = false;
                // 检查是否禁用重连
                if (process.env.VUE_APP_WS_RECONNECT === 'false') {
                    console.log("WebSocket重连已禁用");
                    return;
                }
                Notification.error({ title: 'WebSocket提示', message: '连接断开，正在重连...' });
                // 指数退避重连
                const newTimeout = Math.min(timeout * 2, 30000);
                RetryConnect(newTimeout);
            };

            wsObj.onerror = (err) => {
                console.error("WebSocket 错误", err);
                wbSocket.isConnectState = false;
            };
        } catch (e) {
            console.error("WebSocket初始化错误:", e);
            wbSocket.isConnectState = false;
            // 检查是否禁用重连
            if (process.env.VUE_APP_WS_RECONNECT === 'false') {
                console.log("WebSocket重连已禁用");
                return;
            }
            // 出错后重连
            RetryConnect(timeout);
        }

    }, timeout);
}

// 发送消息
export async function SendMessage(type, data) {
    if (!wsObj || wsObj.readyState !== 1) return;
    const message = JSON.stringify({ Type: type, Data: JSON.stringify(data) });
    wsObj.send(message);
}

// 手动关闭
export async function CloseWebScoket() {
    if (wsObj) {
        console.log("手动关闭 WebSocket");
        wsObj.close();
        wbSocket.isConnectState = false;
    }
}

export default {
    AddSocketMessageMonitor,
    RemoveSocketMessageMonitor,
    RetryConnect,
    SendMessage,
    CloseWebScoket
}